import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolDiscordActivityComponent } from '../../components/patrol-discord-cockpit/patrol-discord-activity/patrol-discord-activity.component';
import { PatrolDiscordCaseRecordComponent } from '../../components/patrol-discord-cockpit/patrol-discord-case-record/patrol-discord-case-record.component';
import { PatrolDiscordModerationLedgerComponent } from '../../components/patrol-discord-cockpit/patrol-discord-moderation-ledger/patrol-discord-moderation-ledger.component';
import { PatrolDiscordModQueueComponent } from '../../components/patrol-discord-cockpit/patrol-discord-mod-queue/patrol-discord-mod-queue.component';
import { PatrolDiscordConnectPanelComponent } from '../../components/patrol-discord-cockpit/patrol-discord-connect-panel/patrol-discord-connect-panel.component';
import { PatrolDiscordGuildSwitcherComponent } from '../../components/patrol-discord-cockpit/patrol-discord-guild-switcher/patrol-discord-guild-switcher.component';
import { PatrolDiscordOverviewComponent } from '../../components/patrol-discord-cockpit/patrol-discord-overview/patrol-discord-overview.component';
import { PatrolDiscordPoliciesComponent } from '../../components/patrol-discord-cockpit/patrol-discord-policies/patrol-discord-policies.component';
import {
  PatrolDiscordCockpitService,
  PatrolDiscordCockpitTab,
} from '../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    RouterLink,
    PatrolDiscordGuildSwitcherComponent,
    PatrolDiscordConnectPanelComponent,
    PatrolDiscordOverviewComponent,
    PatrolDiscordPoliciesComponent,
    PatrolDiscordActivityComponent,
    PatrolDiscordModerationLedgerComponent,
    PatrolDiscordCaseRecordComponent,
    PatrolDiscordModQueueComponent,
  ],
  templateUrl: './patrol-discord.component.html',
  styleUrl: './patrol-discord.component.scss',
})
export class PatrolDiscordComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  readonly botHealth = this.#cockpit.botHealth;
  readonly selectedGuild = this.#cockpit.selectedGuild;
  readonly isGuildConnected = this.#cockpit.isGuildConnected;
  readonly activeTab = this.#cockpit.activeTab;

  readonly tabs: ReadonlyArray<{
    id: PatrolDiscordCockpitTab;
    labelKey: string;
  }> = [
    { id: 'overview', labelKey: 'app.patrol.discord.cockpit.tabs.overview' },
    { id: 'policies', labelKey: 'app.patrol.discord.cockpit.tabs.policies' },
    { id: 'activity', labelKey: 'app.patrol.discord.cockpit.tabs.activity' },
    { id: 'ledger', labelKey: 'app.patrol.discord.cockpit.tabs.ledger' },
    { id: 'cases', labelKey: 'app.patrol.discord.cockpit.tabs.cases' },
    { id: 'queue', labelKey: 'app.patrol.discord.cockpit.tabs.queue' },
  ];

  setTab(tab: PatrolDiscordCockpitTab): void {
    this.#cockpit.setActiveTab(tab);
  }
}
